import { render } from "./UsuarioListDialog.vue?vue&type=template&id=6c3875ec"
import script from "./UsuarioListDialog.vue?vue&type=script&lang=js"
export * from "./UsuarioListDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__